import React from 'react';

import { TestCycleDetails } from '@qality/common-components';
import { Link } from '@qality/common-components/src/atoms/Link';
import { TestCycle } from '@qality/common-model';

import {
  LastTestCycleDetailsViewWrapper,
  ViewMoreLink,
} from './LastTestCycleDetails.styled';

export interface LastTestCycleDetailsProps {
  testCycle: TestCycle;
  isProjectContext: boolean;
  handleViewMore: () => void;
}

export const LastTestCycleDetailsView: React.FC<LastTestCycleDetailsProps> = ({
  testCycle,
  isProjectContext,
  handleViewMore,
}: LastTestCycleDetailsProps) => {
  return (
    <LastTestCycleDetailsViewWrapper>
      <TestCycleDetails
        testCycle={testCycle}
        canEdit={false}
        showProject={!isProjectContext}
        showName={true}
        showCycleStatus={false}
      />
      <ViewMoreLink>
        <Link onClick={handleViewMore}>View more</Link>
      </ViewMoreLink>
    </LastTestCycleDetailsViewWrapper>
  );
};
